import { get, put, post } from '../utils/httpRequests';
import { APIs, KEYS } from '../utils/apis';
import {
  mappingState,
  cpParser,
  generateMonthList,
  groupServiceData,
  // activeCpsParser,
  trackingDelayParser,
  ocStatsParser,
  ocStatsChange,
  getBase64
} from '../utils/assetUtils';
import moment from 'moment';

export const ssrHandler = route => dispatch => {
  return dispatch({
    type: 'CONFIG_REQUEST',
    data: Object.assign({ ssr: true, route })
  });
};

export const fetchMetaData = () => dispatch => {
  dispatch({ type: 'META_DATA_REQUEST' });
  return get({
    url: APIs.META_DATA.GET
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }

      const alertTypes =
        Object.keys(response.data.result.alert_types_data)
          .map(key => response.data.result.alert_types_data[key])
          .sort((a, b) => a.priority - b.priority) || [];

      const severity =
        Object.keys(response.data.result.severity_data)
          .map(key => response.data.result.severity_data[key])
          .sort((a, b) => a.priority - b.priority) || [];

      dispatch({
        type: 'META_DATA_SUCCESS',
        data: Object.assign({
          isFetching: false,
          error: false,
          alertTypes,
          severity
        })
      });
      return alertTypes;
    })
    .catch(function(error) {
      dispatch({
        type: 'META_DATA_FAILURE',
        data: Object.assign({
          alertTypes: [],
          severity: [],
          isFetching: false,
          error: true
        })
      });
      return error;
    });
};

export const fetchUnmappedStatus = query => dispatch => {
  dispatch({ type: 'UNMAPPED_STATUS_REQUEST' });
  let url = APIs.STATUSES.UNMAPPED;
  if (query.shipmentCycle) {
    url += '&shipment_cycle_code=' + query.shipmentCycle;
  }
  if (query.cps && Array.isArray(query.cps) && query.cps.length > 0) {
    url += '&cp_ids=' + query.cps.join(',');
  }
  return get({
    url
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      const unmapped = {
        list: response.data.result,
        isFetching: false,
        error: false
      };
      dispatch({
        type: 'UNMAPPED_STATUS_SUCCESS',
        data: Object.assign({ unmapped })
      });
      return response.data;
    })
    .catch(function(error) {
      const unmapped = { list: [], isFetching: false, error: true };
      dispatch({
        type: 'UNMAPPED_STATUS_FAILURE',
        data: Object.assign({ unmapped })
      });
      return error;
    });
};

export const updateUnmappedStatus = list => (dispatch, getState) => {
  const { unmapped } = getState().session.statuses;
  unmapped.list = list;
  return dispatch({
    type: 'UNMAPPED_STATUS_UPDATE',
    data: Object.assign({ unmapped })
  });
};

export const fetchMappedStatus = () => dispatch => {
  dispatch({ type: 'MAPPED_STATUS_REQUEST' });
  return get({
    url: APIs.STATUSES.MAPPED
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      const mapped = { list: response.data, isFetching: false, error: false };
      dispatch({
        type: 'MAPPED_STATUS_SUCCESS',
        data: Object.assign({ mapped })
      });
      return response.data;
    })
    .catch(function(error) {
      const mapped = { list: [], isFetching: false, error: true };
      dispatch({
        type: 'MAPPED_STATUS_FAILURE',
        data: Object.assign({ mapped })
      });
      return error;
    });
};

export const addNewStatus = data => dispatch => {
  dispatch({
    type: 'NEW_STATUS_REQUEST',
    data: Object.assign({
      newStatus: { success: null, isFetching: true, error: false }
    })
  });
  return post({
    url: APIs.STATUSES.UPDATE,
    data,
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      if (response.data.metaCode === 200) {
        dispatch({
          type: 'NEW_STATUS_SUCCESS',
          data: Object.assign({
            newStatus: { success: true, isFetching: true, error: false }
          })
        });
      } else {
        dispatch({
          type: 'NEW_STATUS_FAILURE',
          data: Object.assign({
            newStatus: { success: false, isFetching: true, error: true }
          })
        });
      }
      return response.data;
    })
    .catch(function(error) {
      dispatch({
        type: 'NEW_STATUS_FAILURE',
        data: Object.assign({
          newStatus: { success: null, isFetching: true, error: true }
        })
      });
      return error;
    });
};

export const fetchAlert = (type, pageNo, startDate, endDate) => dispatch => {
  dispatch({
    type: 'ALERT_REQUEST',
    data: Object.assign({ list: [], totalPages: 0, isFetching: true, pageNo })
  });
  return get({
    url:
      APIs.ALERT.GET +
      '&alert_type=' +
      type +
      (pageNo ? '&page=' + pageNo : '') +
      (startDate && endDate
        ? `&start_date=${startDate}&end_date=${endDate}`
        : '')
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      dispatch({
        type: 'ALERT_SUCCESS',
        data: Object.assign({
          list: response.data.results,
          totalPages: response.data.total_pages,
          type,
          pageNo,
          isFetching: false,
          error: false
        })
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({
        type: 'ALERT_FAILURE',
        data: Object.assign({ isFetching: false, error: true, type, pageNo })
      });
      return error;
    });
};

export const statusChange = idx => (dispatch, getState) => {
  let existingAlert = getState().session.alert;
  const data = existingAlert.list[idx];
  return get({
    url: APIs.ALERT.UPDATE + '&alert_object_id=' + data.id
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      dispatch(fetchAlert(data.alert_type, 1));
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const fetchJobs = () => (dispatch, getState) => {
  let { sorting } = getState().session.jobs;
  dispatch({ type: 'JOBS_REQUEST' });
  return get({ url: APIs.JOBS })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      const mapped = mappingState(response.data.result);
      dispatch({
        type: 'JOBS_SUCCESS',
        data: Object.assign({
          isFetching: false,
          error: false,
          list: mapped,
          raw: mapped,
          sorting
        })
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({
        type: 'JOBS_FAILURE',
        data: Object.assign({
          isFetching: false,
          error: true,
          list: [],
          raw: [],
          sorting
        })
      });
      return error;
    });
};

export const sortingChange = data => dispatch => {
  dispatch({
    type: 'SORTING_CHANGE',
    data
  });
};

export const sortingJobs = () => (dispatch, getState) => {
  let { sorting, list } = getState().session.jobs;
  // console.log(data);
  list.forEach(state => {
    state.list.sort((a, b) => a[sorting.key]?.localeCompare(b[sorting.key]));
    // console.log(state.list.sort((b, a) => a.name - b.name));
  });
  // for (let i = 0; i < data.length; i++) {
  //   data[i].list.sort((b, a) => a.name.localeCompare(b.name));
  // }

  // var d = [{name: 'a', id: 1}, {name: 'b', id: 2}];
  // // d.forEach(item => {
  //   d.sort((b, a) => a.name.localeCompare(b.name))
  // // })
  // console.log(d);

  // data = data.map(state => state.list.sort((a, b) => a.name - b.name))
  // console.log(data);

  dispatch({
    type: 'SORTING_JOBS',
    data: list
  });
};

export const fetchActiveReportsMetaData = filter => (dispatch, getState) => {
  let { reports } = getState().session.activeReports;
  dispatch({ type: 'ENTERPRISE_META_DATA_REQUEST' });
  dispatch({ type: 'ACTIVE_REPORTS_META_DATA_REQUEST' });
  return get({
    url: APIs.ACTIVE_REPORTS.META_DATA + '&filters=' + filter
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      const sortedEnterprises =
        response.data.result.enterprises
          .filter(enterprise => enterprise.name !== null)
          .sort((a, b) => a?.name?.localeCompare(b.name)) || [];
      dispatch({
        type: 'ACTIVE_REPORTS_META_DATA_SUCCESS',
        data: Object.assign({
          isFetching: false,
          error: false,
          enterprises: sortedEnterprises,
          reportTypes: response.data.result.report_metadata || [],
          reports
        })
      });
      dispatch({
        type: 'ENTERPRISE_META_DATA_SUCCESS',
        data: Object.assign({
          enterprises: sortedEnterprises,
          reportTypes: response.data.result.report_metadata || []
        })
      });
      return getState().session.metadata;
    })
    .catch(function(error) {
      dispatch({
        type: 'ACTIVE_REPORTS_META_DATA_FAILURE',
        data: Object.assign({
          isFetching: false,
          error: true,
          enterprises: [],
          reportTypes: [],
          reports
        })
      });
      return error;
    });
};

export const fetchEnterpriseByUser = () => (dispatch, getState) => {
  dispatch({ type: 'USER_ACCESS_REQUEST' });
  return get({
    url: APIs.USER.ENTERPRISES
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }

      if (response.data.meta.status === 200) {
        const sortedEnterprises =
          response.data.result.list.sort((a, b) =>
            a?.name?.localeCompare(b.name)
          ) || [];
        dispatch({
          type: 'USER_ACCESS_SUCCESS',
          data: Object.assign({
            enterprises: sortedEnterprises,
            developer: response.data?.result.developer || false,
            support: response.data?.result.support || false,
            notificationsMigration:
              response.data?.result.notificationsMigration || false,
            userAccessType: response.data?.result.userAccessType || 'admin'
          })
        });
        return getState().session.metadata;
      } else {
        dispatch({
          type: 'USER_ACCESS_FAILURE',
          data: Object.assign({
            isFetching: false,
            error: true,
            enterprises: []
          })
        });
      }
    })
    .catch(function(error) {
      dispatch({
        type: 'USER_ACCESS_FAILURE',
        data: Object.assign({
          isFetching: false,
          error: true,
          enterprises: []
        })
      });
      return error;
    });
};

export const fetchFeatureEnvs = () => dispatch => {
  dispatch({ type: 'FEATURE_ENVS_REQUEST' });
  return get({
    url: APIs.FEATURE_ENVS
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      let body = response.data;
      if (typeof body === 'string') {
        try {
          body = JSON.parse(body);
        } catch (e) {
          body = {};
        }
      }
      const list = Array.isArray(body.result) ? body.result : [];
      dispatch({
        type: 'FEATURE_ENVS_SUCCESS',
        data: list
      });
      return body;
    })
    .catch(function(error) {
      dispatch({
        type: 'FEATURE_ENVS_FAILURE'
      });
      return error;
    });
};

export const updateFeatureEnvs = envs => dispatch => {
  const data = Object.keys(envs || {}).reduce((acc, k) => {
    acc[k] = (envs[k] || []).map(e => ({ ...e }));
    return acc;
  }, {});
  return dispatch({
    type: 'FEATURE_ENVS_UPDATE',
    data
  });
};

export const submitFeatureEnvs = data => dispatch => {
  dispatch({ type: 'FEATURE_ENVS_UPDATE_REQUEST' });
  return post({
    url: APIs.FEATURE_ENVS,
    data
  })
    .then(response => {
      if (!response) {
        dispatch({ type: 'FEATURE_ENVS_UPDATE_FAILURE' });
        return { meta: { status: 0, message: 'No response', success: false } };
      }
      let body = response.data;
      if (typeof body === 'string') {
        try {
          body = JSON.parse(body);
        } catch (e) {
          body = {};
        }
      }
      const ok = response.status >= 200 && response.status < 300;
      if (!ok) {
        dispatch({
          type: 'FEATURE_ENVS_UPDATE_FAILURE',
          error: (body.meta && body.meta.message) || 'Save failed'
        });
        return body;
      }
      dispatch({
        type: 'FEATURE_ENVS_UPDATE_SUCCESS',
        data: body.result || { environments: [] }
      });
      return body;
    })
    .catch(function() {
      dispatch({
        type: 'FEATURE_ENVS_UPDATE_FAILURE',
        error: 'Save failed'
      });
      return { meta: { status: 0, message: 'Save failed', success: false } };
    });
};

export const fetchActiveReports = query => dispatch => {
  dispatch({ type: 'ACTIVE_REPORTS_REQUEST' });
  let url = APIs.ACTIVE_REPORTS.FETCH + '&page=1&page_size=20';
  if (query && query.reportName) {
    url += `&report_name=${query.reportName}`;
  }
  if (query && query.enterprise) {
    url += `&enterprise_id=${query.enterprise}`;
  }
  if (query && query.active !== null) {
    url += `&is_enabled=${query.active}`;
  }
  return get({ url })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      let { report, count } = response.data.result;
      report = report.map(item => {
        if (item.email_cc_list) {
          const emails = item.email_cc_list
            .replace(/\//g, '')
            .replace(/'/g, '"');
          try {
            item.email_cc_list = JSON.parse(emails).join(', ');
          } catch (error) {
            item.email_cc_list = emails;
            item.hasError = true;
          }
        }
        if (item.email_to_list) {
          const emails = item.email_to_list
            .replace(/\//g, '')
            .replace(/'/g, '"');
          try {
            item.email_to_list = JSON.parse(emails).join(', ');
          } catch (error) {
            item.email_to_list = emails;
            item.hasError = true;
          }
        }
        return item;
      });
      dispatch({
        type: 'ACTIVE_REPORTS_SUCCESS',
        data: Object.assign({
          isFetching: false,
          error: false,
          list: report,
          count
        })
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({
        type: 'ACTIVE_REPORTS_FAILURE',
        data: Object.assign({
          isFetching: false,
          error: true,
          list: [],
          count: 0
        })
      });
      return error;
    });
};

export const fetchPaginatedActiveReports = query => (dispatch, getState) => {
  const { reports } = getState().session.activeReports;
  dispatch({ type: 'ACTIVE_REPORTS_PAGINATION_REQUEST' });
  let url =
    APIs.ACTIVE_REPORTS.FETCH + `&page=${reports.pageNo + 1}&page_size=20`;
  if (query && query.reportName) {
    url += query.reportName ? `&report_name=${query.reportName}` : '';
  }
  if (query && query.enterprise) {
    url += query.enterprise ? `&enterprise_id=${query.enterprise}` : '';
  }
  return get({ url }).then(response => {
    if (!response) {
      throw Error(response.statusText);
    }
    let { report } = response.data.result;
    report = report.map(item => {
      if (item.email_cc_list) {
        const emails = item.email_cc_list.replace(/\//g, '').replace(/'/g, '"');
        try {
          item.email_cc_list = JSON.parse(emails).join(', ');
        } catch (error) {
          item.email_cc_list = emails;
          item.hasError = true;
        }
      }
      if (item.email_to_list) {
        const emails = item.email_to_list.replace(/\//g, '').replace(/'/g, '"');
        try {
          item.email_to_list = JSON.parse(emails).join(', ');
        } catch (error) {
          item.email_to_list = emails;
          item.hasError = true;
        }
      }
      return item;
    });
    dispatch({
      type: 'ACTIVE_REPORTS_PAGINATION_SUCCESS',
      data: Object.assign({
        list: reports.list.concat(report)
      })
    });
    return response.data;
  });
};

export const fetchCP = enterprise => dispatch => {
  dispatch({ type: 'CP_META_DATA_REQUEST' });
  return get({
    url:
      APIs.SHIPPING_LABEL.META_DATA +
      'key=' +
      enterprise.key +
      '&enterprise_id=' +
      enterprise.id
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      const { cps, accounts } = cpParser(response.data.results.cps);
      dispatch({
        type: 'CP_META_DATA_SUCCESS',
        data: Object.assign({
          isFetching: false,
          error: false,
          list: cps.sort((a, b) => a?.name?.localeCompare(b?.name)),
          accounts: accounts.sort((a, b) => a?.name?.localeCompare(b?.name))
        })
      });
      return { cps, accounts };
    })
    .catch(function(error) {
      dispatch({
        type: 'CP_META_DATA_FAILURE',
        data: Object.assign({
          isFetching: false,
          error: true,
          list: [],
          accounts: []
        })
      });
      return error;
    });
};

export const resetCPs = () => dispatch => {
  dispatch({ type: 'CP_META_DATA_RESET' });
};

export const fetchServiceMetaData = () => dispatch => {
  dispatch({ type: 'SERVICE_META_DATA_REQUEST' });
  return get({
    url: APIs.META_DATA.SERVICE
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      const cps =
        response.data.result.courier_partner.map(item => ({
          id: item.partner_id,
          name: item.name
        })) || [];
      const services =
        response.data.result.service.map(item => ({
          id: item.service_id,
          name: item.service_name
        })) || [];
      dispatch({
        type: 'SERVICE_META_DATA_SUCCESS',
        data: {
          cps: cps.sort((a, b) => a?.name?.localeCompare(b.name)),
          services: services.sort((a, b) => a?.name?.localeCompare(b.name))
        }
      });
      return { cps, services };
    })
    .catch(function(error) {
      dispatch({ type: 'SERVICE_META_DATA_FAILURE' });
      return error;
    });
};

export const fetchShippingLabels = query => dispatch => {
  dispatch({ type: 'SHIPPING_LABELS_REQUEST' });
  let url =
    APIs.SHIPPING_LABEL.FETCH + 'key=' + query.key + '&page=1&page_size=50';
  if (query) {
    if (query.id) {
      url += `&enterprise_id=${query.id}`;
    }
    if (query.cp_id) {
      url += `&cp_id=${query.cp_id}`;
    }
    if (query.account_id) {
      url += `&account_id=${query.account_id}`;
    }
  }
  return get({ url })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      let { templates, count } = response.data.result;
      dispatch({
        type: 'SHIPPING_LABELS_SUCCESS',
        data: Object.assign({
          isFetching: false,
          error: false,
          list: templates,
          count
        })
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({
        type: 'SHIPPING_LABELS_FAILURE',
        data: Object.assign({
          isFetching: false,
          error: true,
          list: [],
          count: 0
        })
      });
      return error;
    });
};

export const fetchEmailMetaData = () => dispatch => {
  dispatch({ type: 'EMAIL_TEMPLATE_METADATA_REQUEST' });
  let url = APIs.EMAIL_TEMPLATE.META_DATA;
  return get({ url })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      let { notification } = response.data.result;
      dispatch({
        type: 'EMAIL_TEMPLATE_METADATA_SUCCESS',
        data: notification
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({
        type: 'EMAIL_TEMPLATE_METADATA_FAILURE',
        data: Object.assign({
          isFetching: false,
          error: true,
          list: [],
          count: 0
        })
      });
      return error;
    });
};

export const fetchEmailTemplate = () => dispatch => {
  dispatch({ type: 'EMAIL_TEMPLATE_REQUEST' });
  let url = APIs.EMAIL_TEMPLATE.FETCH;
  return get({ url })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      let { templates } = response.data.result;
      dispatch({
        type: 'EMAIL_TEMPLATE_SUCCESS',
        data: templates
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({
        type: 'EMAIL_TEMPLATE_FAILURE'
      });
      return error;
    });
};

export const postEmailTemplate = data => () => {
  let url = APIs.EMAIL_TEMPLATE.FETCH;
  return post({ url, data })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const fetchPaginatedShippingLabels = query => (dispatch, getState) => {
  const { shippingLabels } = getState().session;
  dispatch({ type: 'SHIPPING_LABELS_PAGINATION_REQUEST' });
  let url =
    APIs.SHIPPING_LABEL.FETCH +
    `&page=${shippingLabels.pageNo + 1}&page_size=50`;
  if (query && query.enterprise) {
    url += query.enterprise ? `&enterprise_id=${query.enterprise}` : '';
  }
  return get({ url }).then(response => {
    if (!response) {
      throw Error(response.statusText);
    }
    let { templates } = response.data.result;
    dispatch({
      type: 'SHIPPING_LABELS_PAGINATION_SUCCESS',
      data: Object.assign({
        list: shippingLabels.list.concat(templates)
      })
    });
    return response.data;
  });
};

export const postShippingLabels = data => () => {
  // dispatch({ type: 'SHIPPING_LABELS_REQUEST' });
  let url = APIs.SHIPPING_LABEL.FETCH + 'key=' + data.key;
  // if(query){
  //   if (query.enterprise) {
  //     url += `&enterprise=${query.enterprise}`;
  //   }
  //   if (query.cp_id) {
  //     url += `&cp_id=${query.cp_id}`;
  //   }
  //   if (query.account_id) {
  //     url += `&account_id=${query.account_id}`;
  //   }
  // }
  return post({ url, data })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      // let { templates, count } = response.data.results;
      // dispatch({
      //   type: 'SHIPPING_LABELS_SUCCESS',
      //   data: Object.assign({
      //     isFetching: false,
      //     error: false,
      //     list: templates,
      //     count
      //   })
      // });
      return response.data;
    })
    .catch(function(error) {
      // dispatch({
      //   type: 'SHIPPING_LABELS_FAILURE',
      //   data: Object.assign({
      //     isFetching: false,
      //     error: true,
      //     list: [],
      //     count: 0
      //   })
      // });
      return error;
    });
};

export const putShippingLabels = data => () => {
  let url = APIs.SHIPPING_LABEL.FETCH + 'key=' + data.key;
  return put({ url, data })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const resetShippingLabels = () => dispatch => {
  dispatch({ type: 'SHIPPING_LABELS_RESET' });
};

export const fetchShipmentLog = query => dispatch => {
  dispatch({ type: 'SHIPMENT_LOG_REQUEST' });
  let url = APIs.SHIPMENT_LOG.FETCH;
  if (query?.enterprise) {
    url += query.enterprise
      ? `&enterprise_user_profile_id=${query.enterprise}`
      : '';
  }
  // If the service type is Tracking(2) and search by AWB then pass the AWB number in the query.
  if (
    query?.searchInput &&
    query?.serviceType === 2 &&
    query?.searchBy === 'awb'
  ) {
    url += query.searchInput ? `&awb=${query.searchInput}` : '';
  } else if (query?.searchInput && query.serviceType === 26) {
    // If the service type is Order Cancellation Service(26) then pass the AWB number in the query.
    url += query.searchInput ? `&awb=${query.searchInput}` : '';
  } else if (query?.searchInput) {
    url += query.searchInput ? `&reference_number=${query.searchInput}` : '';
  }
  if (query && query.serviceType) {
    url += query.serviceType ? `&service_id=${query.serviceType}` : '';
  }
  if (query && query.cpAccountId) {
    url += query.cpAccountId ? `&account_id=${query.cpAccountId}` : '';
  }
  if (query && query.startDate) {
    url += query.startDate ? `&start_date=${query.startDate}` : '';
  }
  if (query && query.endDate) {
    url += query.endDate ? `&end_date=${query.endDate}` : '';
  }
  return get({ url })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      dispatch({
        type: 'SHIPMENT_LOG_SUCCESS',
        data: Object.assign({
          list: response.data.result || []
        })
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'SHIPMENT_LOG_FAILURE' });
      return error;
    });
};

export const resetShipmentLog = () => dispatch => {
  dispatch({ type: 'SHIPMENT_LOG_RESET' });
};

export const fetchSampleTemplates = () => dispatch => {
  dispatch({ type: 'SAMPLE_TEMPLATES_REQUEST' });
  let url = APIs.SHIPPING_LABEL.SAMPLE + '&page=1&page_size=50';
  return get({ url })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      let { templates } = response.data.result;
      dispatch({
        type: 'SAMPLE_TEMPLATES_SUCCESS',
        data: Object.assign({
          isFetching: false,
          error: false,
          list: templates.map(item => {
            item.tags = Object.keys(item.tags).join(', ');
            return item;
          })
        })
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({
        type: 'SAMPLE_TEMPLATES_FAILURE',
        data: Object.assign({
          isFetching: false,
          error: true,
          list: []
        })
      });
      return error;
    });
};

export const uploadFileToS3 = fileInfo => dispatch => {
  let data = new FormData();
  data.append('key', fileInfo.fields.key);
  data.append('AWSAccessKeyId', fileInfo.fields.AWSAccessKeyId);
  data.append('policy', fileInfo.fields.policy);
  data.append('signature', fileInfo.fields.signature);
  data.append('x-amz-security-token', fileInfo.fields['x-amz-security-token']);
  data.append('file', fileInfo.file);
  return post({ url: fileInfo.url, data })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      if (response.status === 204) {
        fileInfo.s3Url = fileInfo.url + fileInfo.fields.key;
        dispatch({
          type: 'PRE_SIGNED_URL_UPLOADED',
          data: fileInfo
        });
      }
      return response;
    })
    .catch(function(error) {
      return error;
    });
};

export const preSignedUrl = preUrl => dispatch => {
  return get({
    url: APIs.S3_PRESIGNED_URL + `file_key=${preUrl}&key=${KEYS.FILE_UPLOAD}`
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      const file = {};
      file.url = response.data.result.url;
      file.fields = response.data.result.fields;
      dispatch({
        type: 'PRE_SIGNED_URL_SHIPPING_LABEL',
        data: file
      });
      return response.data.result;
    })
    .catch(function(error) {
      return error;
    });
};

export const replicateS3File = query => () => {
  return get({
    url:
      APIs.REPLICATE_S3_FILE +
      `source=${query.source}&destination=${query.destination}&key=${KEYS.FILE_UPLOAD}`
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const fetchBilling = query => dispatch => {
  // const { serviceType } = getState().billing;
  dispatch({ type: 'BILLING_REQUEST' });
  let url = `${APIs.BILLING.FETCH}isInternal=true`;
  if (query.enterpriseId) {
    url += `&enterprise_id=${query.enterpriseId}`;
  }
  if (query.months) {
    url += `&months=${query.months}`;
  }
  return get({ url })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      // console.log(response.data.result.monthly_data);
      let list = [];
      if (query.serviceType && query.serviceType.length > 0) {
        list = groupServiceData(
          response.data.result.monthly_data,
          query.serviceType
        );
      } else {
        list = groupServiceData(response.data.result.monthly_data);
      }
      const sorted = response.data.result.service_types.sort();
      dispatch({
        type: 'BILLING_SUCCESS',
        data: Object.assign({
          list,
          serviceType: sorted.map(service => ({
            value: service,
            label: service
          })),
          months: generateMonthList() || []
        })
      });

      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'BILLING_FAILURE' });
      return error;
    });
};

export const fetchBillingMetaData = () => dispatch => {
  // const { serviceType } = getState().billing;
  dispatch({ type: 'BILLING_META_DATA_REQUEST' });
  return get({
    url: `${APIs.BILLING.META_DATA}`
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      const sorted = response.data.result.sort();
      dispatch({
        type: 'BILLING_META_DATA_SUCCESS',
        data: sorted.map(item => ({
          value: item,
          label: item
        }))
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'BILLING_META_DATA_FAILURE' });
      return error;
    });
};

export const fetchBillingServiceMetaData = () => dispatch => {
  // const { serviceType } = getState().billing;
  dispatch({ type: 'BILLING_SERVICE_META_DATA_REQUEST' });
  return get({
    url: `${APIs.BILLING.SERVICE_META_DATA}`
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      const sorted = response.data.result.sort();
      dispatch({
        type: 'BILLING_SERVICE_META_DATA_SUCCESS',
        data: sorted.map(item => ({
          value: item,
          label: item
        }))
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'BILLING_SERVICE_META_DATA_FAILURE' });
      return error;
    });
};

export const fetchBillingRuleMetaData = () => dispatch => {
  // const { serviceType } = getState().billing;
  dispatch({ type: 'BILLING_RULE_META_DATA_REQUEST' });
  return get({
    url: `${APIs.BILLING.RULE_META_DATA}`
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      const sorted = response.data.result.sort();
      dispatch({
        type: 'BILLING_RULE_META_DATA_SUCCESS',
        data: sorted.map(item => ({
          value: item,
          label: item
        }))
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'BILLING_RULE_META_DATA_FAILURE' });
      return error;
    });
};

export const postBilling = data => dispatch => {
  // const { serviceType } = getState().billing;
  dispatch({ type: 'BILLING_DATA_REQUEST' });
  data.serviceTypeData = data.serviceTypeData.map(item => {
    if (!item.perUnitCost) {
      item.perUnitCost = 0;
    }
    if (!item.fixedPrice) {
      item.fixedPrice = 0;
    }
    item.unit = 0;
    return item;
  });
  return post({
    url: `${APIs.BILLING.POST}`,
    data
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      dispatch({
        type: 'BILLING_DATA_SUCCESS',
        data: []
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'BILLING_DATA_FAILURE' });
      return error;
    });
};

export const getBilling = enterpriseId => dispatch => {
  // const { serviceType } = getState().billing;
  dispatch({ type: 'BILLING_FETCH_DATA_REQUEST' });
  return get({
    url: `${APIs.BILLING.FETCH_BILLING}enterprise_id=${enterpriseId}`
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      dispatch({
        type: 'BILLING_FETCH_DATA_SUCCESS',
        data: response.data.result
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'BILLING_FETCH_DATA_FAILURE' });
      return error;
    });
};

export const fetchTrackingDelay = query => (dispatch, getState) => {
  const cpList = getState().session.metadata.cp.list;
  dispatch({ type: 'TRACKING_DELAY_REQUEST' });
  let url = APIs.TRACKING_DELAY.FETCH;
  if (query) {
    if (query.enterpriseId) {
      url += `&enterprise_id=${query.enterpriseId}`;
    }
    if (query.cps) {
      url += `&courier_partner_id=${query.cps.join(',')}`;
    }
    if (query.startDate) {
      url += `&start_date=${query.startDate}`;
    }
    if (query.endDate) {
      url += `&end_date=${query.endDate}`;
    }
  }
  return get({ url })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      const { list, legends, colors } = trackingDelayParser(
        response.data.result,
        query.cps,
        cpList
      );
      dispatch({
        type: 'TRACKING_DELAY_SUCCESS',
        data: Object.assign({
          isFetching: false,
          error: false,
          list,
          legends,
          colors
        })
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'TRACKING_DELAY_FAILURE' });
      return error;
    });
};

export const fetchTrackingDelayPercentile = query => (dispatch, getState) => {
  const cpList = getState().session.metadata.cp.list;
  dispatch({ type: 'TRACKING_DELAY_PERCENTILE_REQUEST' });
  let url = APIs.TRACKING_DELAY.FETCH_PERCENTILE;
  if (query) {
    if (query.enterpriseId) {
      url += `&enterprise_id=${query.enterpriseId}`;
    }
    if (query.cps) {
      url += `&courier_partner_id=${query.cps.join(',')}`;
    }
    if (query.startDate) {
      url += `&start_date=${query.startDate}`;
    }
    if (query.endDate) {
      url += `&end_date=${query.endDate}`;
    }
    if (query.percentile) {
      url += `&percentile=${query.percentile}`;
    }
  }
  return get({ url })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      const { list, legends, colors } = trackingDelayParser(
        response.data.result,
        query.cps,
        cpList,
        true
      );
      dispatch({
        type: 'TRACKING_DELAY_PERCENTILE_SUCCESS',
        data: Object.assign({
          isFetching: false,
          error: false,
          list,
          legends,
          colors
        })
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'TRACKING_DELAY_PERCENTILE_FAILURE' });
      return error;
    });
};

export const fetchOrderCreationStats = query => (dispatch, getState) => {
  const cpList = getState().session.metadata.cp.list;
  dispatch({ type: 'ORDER_CREATION_REQUEST' });
  let url = APIs.ORDER_CREATION;
  if (query) {
    if (query.enterpriseId) {
      url += `&enterprise_id=${query.enterpriseId}`;
    }
    if (query.cps) {
      url += `&courier_partner_id=${query.cps.join(',')}`;
    }
    if (query.startDate) {
      url += `&start_date=${query.startDate}`;
    }
    if (query.endDate) {
      url += `&end_date=${query.endDate}`;
    }
  }
  return get({ url })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      const diffDuration = moment.duration(
        moment(query.endDate).diff(query.startDate)
      );
      const day = diffDuration.days();
      const { list, legends, colors } = ocStatsParser(
        response.data.result,
        query.cps,
        cpList,
        day
      );
      dispatch({
        type: 'ORDER_CREATION_SUCCESS',
        data: Object.assign({
          isFetching: false,
          error: false,
          list,
          legends,
          colors
        })
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'ORDER_CREATION_FAILURE' });
      return error;
    });
};

export const orderCreationChartChange = key => (dispatch, getState) => {
  let { orderCreation } = getState().session;
  const { list, legends } = ocStatsChange(orderCreation, key);
  dispatch({ type: 'ORDER_CREATION_CHANGE', data: { key, list, legends } });
};

export const generateOrderCreationReport = data => () => {
  return post({
    url: APIs.GENERATE_REPORT,
    data,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token KEYS.TOKEN`
    }
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const fetchWarehouse = () => dispatch => {
  dispatch({ type: 'WAREHOUSE_REQUEST' });
  return get({
    url: `${APIs.WAREHOUSE.FETCH}`
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      dispatch({
        type: 'WAREHOUSE_SUCCESS',
        data: {
          cities: response.data.result.city_name || [],
          unmapped: response.data.result.unmapped_location || []
        }
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'WAREHOUSE_FAILURE' });
      return error;
    });
};

export const putWarehouse = (data, idx) => (dispatch, getState) => {
  let { unmapped } = getState().session.warehouse;
  dispatch({ type: 'WAREHOUSE_UPDATE_REQUEST' });
  return put({
    url: `${APIs.WAREHOUSE.FETCH}`,
    data,
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      unmapped.splice(idx, 1);
      dispatch({
        type: 'WAREHOUSE_UPDATE_SUCCESS',
        data: { unmapped }
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'WAREHOUSE_UPDATE_FAILURE' });
      return error;
    });
};

export const fetchAsyncLogMetaData = enterpriseId => dispatch => {
  dispatch({ type: 'SHIPMENT_LOG_ASYNC_METADATA_REQUEST' });
  return get({
    url: `${APIs.SHIPMENT_LOG.ASYNC_METADATA}&enterprise_user_id=${enterpriseId}`
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      dispatch({
        type: 'SHIPMENT_LOG_ASYNC_METADATA_SUCCESS',
        data: response.data.result
          ? Object.keys(response.data.result).map(function(key) {
              return { label: key, value: response.data.result[key] };
            })
          : []
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'SHIPMENT_LOG_ASYNC_METADATA_FAILURE' });
      return error;
    });
};

export const fetchAsyncLog = jobId => (dispatch, getState) => {
  let { unmapped } = getState().session.warehouse;
  dispatch({ type: 'SHIPMENT_LOG_ASYNC_REQUEST' });
  return get({
    url: `${APIs.SHIPMENT_LOG.ASYNC}job_id=${jobId}`
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      dispatch({
        type: 'SHIPMENT_LOG_ASYNC_SUCCESS',
        data: { unmapped }
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'SHIPMENT_LOG_ASYNC_FAILURE' });
      return error;
    });
};

export const postAsyncLog = data => dispatch => {
  dispatch({ type: 'SHIPMENT_LOG_ASYNC_POST_REQUEST' });
  return post({
    url: `${APIs.SHIPMENT_LOG.ASYNC}`,
    data,
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      dispatch({
        type: 'SHIPMENT_LOG_ASYNC_POST_SUCCESS',
        data: response.data.result.job_id
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'SHIPMENT_LOG_ASYNC_POST_FAILURE' });
      return error;
    });
};

export const fetchBillingThreshold = enterpriseId => dispatch => {
  dispatch({ type: 'BILLING_THRESHOLD_REQUEST' });
  return get({
    url: `${APIs.BILLING.THRESHOLD.FETCH}enterprise_id=${enterpriseId}`
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      dispatch({
        type: 'BILLING_THRESHOLD_SUCCESS',
        data: response.data
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'BILLING_THRESHOLD_FAILURE' });
      return error;
    });
};

export const postBillingThreshold = data => dispatch => {
  dispatch({ type: 'BILLING_THRESHOLD_REQUEST' });
  return post({
    url: `${APIs.BILLING.THRESHOLD.POST}`,
    data: { enterpriseThresholdData: [data] },
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const fetchEc2Machine = () => dispatch => {
  dispatch({ type: 'EC2_MACHINE_REQUEST' });
  return get({
    url: `${APIs.ALERT.REBOOT}`
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      dispatch({
        type: 'EC2_MACHINE_SUCCESS',
        data: response.data.result
      });
      return response.data;
    })
    .catch(function(error) {
      dispatch({ type: 'EC2_MACHINE_FAILURE' });
      return error;
    });
};

export const rebootMachine = instance_ids => () => {
  return post({
    url: `${APIs.ALERT.REBOOT}`,
    data: { instance_ids },
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const dashboardLogin = enterpriseId => () => {
  return get({
    url: `${APIs.DASHBOARD_LOGIN}&enterprise_id=${enterpriseId}`,
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const fetchScans = (enterpriseId, awb) => () => {
  return get({
    url: `${APIs.SHIPMENT_LOG.SCANS}awb=${awb}&enterprise_user_id=${enterpriseId}`
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const postSampleTemplate = data => () => {
  let url = `${APIs.SHIPPING_LABEL.SAMPLE}`;
  return post({ url, data })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const getSmsNotifications = (awb_number, enterprise_id) => {
  let url = `${APIs.SHIPMENT_LOG.SMS_NOTIFICATION}awb_number=${awb_number}&enterprise_id=${enterprise_id}`;
  return get({ url })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const getEmailNotifications = (awb_number, enterprise_id) => {
  let url = `${APIs.SHIPMENT_LOG.EMAIL_NOTIFICATION}awb_number=${awb_number}&enterprise_id=${enterprise_id}`;
  return get({ url })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const qcParameterFetch = cpId => {
  return get({
    url: `${APIs.QC_PARAMETER.FETCH}partner_id=${cpId}`,
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const courierAccountsFetch = enterprise => {
  return get({
    url: APIs.QC_PARAMETER.COURIER_ACCOUNTS + '&enterprise_id=' + enterprise.id,
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const qcParameterSelectedFetch = (enterpriseId, accountId) => {
  return get({
    url: `${APIs.QC_PARAMETER.POST}enterprise_id=${enterpriseId}&account_id=${accountId}`,
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};
export const enterpriseList = enterprise => {
  return get({
    url: `${APIs.ACTIVE_REPORTS.META_DATA}filters=${enterprise}`,
    headers: { 'Content-Type': 'application/json' }
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      if (response.data?.result?.enterprises) {
        response.data.result.enterprises = response.data.result.enterprises.filter(
          enterprises => enterprises.name
        );
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const fetchCPData = enterprise => {
  return get({
    url:
      APIs.SHIPPING_LABEL.META_DATA +
      'key=' +
      enterprise.key +
      '&enterprise_id=' +
      enterprise.id
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const postQcParameter = data => {
  let url = `${APIs.QC_PARAMETER.POST}`;
  return post({ url, data })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const postReleaseNotes = data => {
  let url = `${APIs.RELEASE_NOTES}`;
  return post({ url, data })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      return response.data;
    })
    .catch(function(error) {
      return error;
    });
};

export const uploadFileToS3Replica = fileInfo => {
  let data = new FormData();
  Object.keys(fileInfo.fields).forEach(key => {
    data.append(key, fileInfo.fields[key]);
  });
  data.append('file', fileInfo.file);
  return post({ url: fileInfo.url, data, noToken: true })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      if (response.status === 204) {
        fileInfo.s3Url = fileInfo.url + fileInfo.fields.key;
      }
      return response;
    })
    .catch(function(error) {
      return error;
    });
};
export const preSignedUrlReplica = preUrl => {
  return get({
    url: APIs.S3_PRESIGNED_URL + `file_key=${preUrl}&key=${KEYS.FILE_UPLOAD}`
  })
    .then(response => {
      if (!response) {
        throw Error(response.statusText);
      }
      const file = {};
      file.url = response.data.result.url;
      file.fields = response.data.result.fields;

      return response.data.result;
    })
    .catch(function(error) {
      return error;
    });
};

export const commonFileUpload = (file, preUrlPrefix, uploadCallback) => {
  if (file) {
    const fileName = file.name;
    const fileExtension = fileName
      .split('.')
      .pop()
      .toLowerCase();

    let preUrl = `${preUrlPrefix}${parseInt(
      new Date().getTime() / 1000
    )}.${fileExtension}`;
    getBase64(file, () => {
      preSignedUrlReplica(preUrl).then(res => {
        if (res) {
          const { url, fields } = res;
          uploadFileToS3Replica({ file, url, fields }).then(() => {
            uploadCallback(
              'https://pyck-res-bucket.s3.amazonaws.com/' + preUrl
            );
          });
        }
      });
    });
  } else {
    throw Error('No file found');
  }
};
